<template>
    <form-modal :value="modal" @input="close"
        :title="$t('dashboard.comment')"
        size="xl"
        :centered="false"
    >
        <form @submit.prevent="submit"
            v-if="features.canEdit()"
            >
            <base-input>
                <textarea class="form-control"
                    :placeholder="$t('dashboard.enter-comment-here')"
                    rows="25"
                    v-model="content"
                >

                </textarea>
            </base-input>

            <div class="text-center">

                <base-button type="primary" @click.prevent="submit" :loading="recording">
                    {{ $t('common.save') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="close">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>

        <div class="pb-3" v-else>
            <!-- Keep it on the same line -->
            <div class="description" v-if="content && content.trim().length > 0">{{content}}</div>
            <div v-else>
                {{ $t('dashboard.no-comment') }}
            </div>
        </div>
    </form-modal>
</template>

<script>
    export default {

        model: {
            prop: 'modal',
            event: 'input'
        },
        
        props: {

            modal: {
                type: Object,
                required: true
            },

            comment: {
                type: String,
                required: true
            },

            features: {
                default: null
            },
        },

        data() {

            return {
                recording: false,
                content: ''
            }
        },

        watch: {
            modal(val) {
                if (val.show) {
                    // The modal has just been opened. (Re)initialize the content.
                    this.content = this.comment
                }
            }
        },

        methods: {

            submit() {
                this.$emit('change', this.content)
                this.close()
            },

            close() {
                this.$emit('input', {
                    show: false,
                })
            }
        }
    }
</script>

<style lang="css" scoped>
    .description {
        white-space: pre-wrap;
    }
</style>

